export const ERRORS_NEW = "ERRORS_NEW";
export const ERRORS_CLEAR = "ERRORS_CLEAR";
